module.exports = __webpack_public_path__ + "img/serves.8a5dea0c.png";